module.exports = __webpack_public_path__ + "static/media/operation_book.e34f86da.jpg";